import { Text, View } from "@react-pdf/renderer";

export interface PdfPatientInformationCardProps {
  nameWithAge: string;
  dateOfBirth: string;
  gender: string;
  occupation: string;
  maritalStatus: string;
  meetingTimeRange?: string | null;
}

const cardStyle = {
  backgroundColor: "#F5F5F5",
  borderRadius: 8,
  flexDirection: "column" as const,
  padding: 12,
  rowGap: 4,
};

const titleStyle = {
  fontWeight: 600,
  fontSize: 16,
  marginBottom: 4,
};

export const PdfPatientInformationCard = ({
  nameWithAge,
  dateOfBirth,
  gender,
  occupation,
  maritalStatus,
  meetingTimeRange,
}: PdfPatientInformationCardProps) => (
  <View style={cardStyle} wrap={false}>
    <Text style={titleStyle}>{nameWithAge}</Text>
    <Text>Date of birth: {dateOfBirth}</Text>
    <Text>Gender: {gender}</Text>
    <Text>Occupation: {occupation}</Text>
    <Text>Relationship status: {maritalStatus}</Text>
    {meetingTimeRange ? <Text>Meeting: {meetingTimeRange}</Text> : null}
  </View>
);
